/*
 * File: ui-text-empty.ts
 * File Created: 2024-09-05 05:20:14
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-08 08:09:18
 * Modified By: Val Liu
 * -----
 */

import { AnyHelper } from "@root/core";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "../core";

/// @uiTextEmpty - show up on table cell when the value is null or undefined.

@UITag.set({
    alias: "uiEmptyText",
})
export class uiTextEmpty extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.String];
    allowNullRule: boolean = false;

    /// set prop sortable: true / false
    parse(input: IUITagInput): IUITagResult {
        /// default: true
        /// rule: true / false
        const rule = this.parseRule(input);

        return {
            props: {
                data: {
                    "text-empty": rule,
                },
            },
        };
    }
}
